import { Badge, Card, CardContent, CardHeader, CardTitle } from "@devhop/ui";
import { Link } from "@tanstack/react-router";
import { formatKip } from "@/modules/cf-feed/presentation/ui/table-helpers";
import { formatDbInBangkokLocale } from "@/shared/lib/date-time";
import type { CfDashboardRecentOrder } from "../api/types";

// system enum -> label ลาว
const STATUS_LABEL: Record<string, string> = {
  pending: "ລໍຖ້າ",
  confirmed: "ຢືນຢັນ",
  paid: "ຈ່າຍແລ້ວ",
  shipped: "ຈັດສົ່ງ",
  delivered: "ສົ່ງຮອດ",
  cancelled: "ຍົກເລີກ",
};

type RecentOrdersCardProps = {
  data?: CfDashboardRecentOrder[];
  isLoading: boolean;
};

export function RecentOrdersCard({ data, isLoading }: RecentOrdersCardProps) {
  const items = data ?? [];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-base">ອໍເດີຫຼ້າສຸດ (ຊ່ວງທີ່ເລືອກ)</CardTitle>
        <Link to="/app/orders" className="text-primary text-xs underline">
          ເບິ່ງທັງໝົດ
        </Link>
      </CardHeader>
      <CardContent>
        {isLoading && items.length === 0 ? (
          <div className="space-y-2 py-2">
            {[0, 1, 2, 3, 4].map((i) => (
              <div key={i} className="h-8 w-full animate-pulse rounded bg-muted" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="py-8 text-center text-muted-foreground text-sm">
            ຍັງບໍ່ມີອໍເດີ
          </div>
        ) : (
          <div className="divide-y">
            {items.map((o) => (
              <div
                key={o.id}
                className="flex items-center justify-between gap-3 py-2.5"
              >
                <div className="min-w-0">
                  <div className="truncate font-medium text-sm">
                    {o.customerName || o.customerFbId || "-"}
                  </div>
                  <div className="truncate text-muted-foreground text-xs">
                    {o.cfCodeUsed} · x{o.quantity} ·{" "}
                    {formatDbInBangkokLocale(o.createdAt, "lo-LA", {
                      dateStyle: "short",
                      timeStyle: "short",
                    })}
                  </div>
                </div>
                <div className="flex shrink-0 items-center gap-3">
                  <span className="font-medium text-sm tabular-nums">
                    {formatKip(o.totalPrice)}
                  </span>
                  <Badge variant="outline" className="shrink-0">
                    {STATUS_LABEL[o.status] ?? o.status}
                  </Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
